module.exports = __webpack_public_path__ + "static/img/zdfx.8d65921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/zdfx.png
// module id = 14Nv
// module chunks = 0